import { Switch, Route } from "react-router-dom";
import { KASIR_PREFIX_PATH } from "configs/AppConfig";
import { handleGet } from "redux/actions/baseAction";
import React, { lazy, Suspense, useEffect } from "react";
import Loading from "components/shared-components/Loading";

export const KasirViews = () => {
  useEffect(() => {
    handleGet("pos/pos/cashier/location", (res) => {
      localStorage.setItem("statusClosing", res.is_open ? "OPEN" : "CLOSE");
    });
  }, []);

  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route
          path={`${KASIR_PREFIX_PATH}/produk-batch-pengiriman`}
          component={lazy(() => import("./produk-batch-pengiriman/index"))}
        />
        <Route
          path={`${KASIR_PREFIX_PATH}/delivery-detail/:id`}
          component={lazy(() => import("./delivery/detail/index"))}
        />
        <Route
          path={`${KASIR_PREFIX_PATH}/transaksi`}
          component={lazy(() => import("./transaksi/index"))}
        />
        <Route
          path={`${KASIR_PREFIX_PATH}/inventory`}
          component={lazy(() => import("./inventory/index"))}
        />
        <Route
          path={`${KASIR_PREFIX_PATH}/stok-harian`}
          component={lazy(() => import("./stok-harian/index"))}
        />
        <Route
          path={`${KASIR_PREFIX_PATH}/laporan-penjualan`}
          component={lazy(() => import("./laporan-penjualan/index"))}
        />
        <Route
          path={`${KASIR_PREFIX_PATH}/pengiriman-produk`}
          component={lazy(() => import("./pengiriman-produk/index"))}
        />
        <Route
          path={`${KASIR_PREFIX_PATH}/delivery`}
          component={lazy(() => import("./delivery/index"))}
        />
        <Route
          path={`${KASIR_PREFIX_PATH}/top-up-and-billing`}
          component={lazy(() => import("./top-up-and-billing/index"))}
        />
      </Switch>
    </Suspense>
  );
};

export default React.memo(KasirViews);
